export const COMPANY = {
  name: "North Emerald Holdings",
  legal: "North Emerald Holdings LLC",
  tagline: "Property Management",
  phone: "914-613-6622",
  email: "support@northemeraldholdings.com",
  address: "119 Pondfield Rd, Unit 424, Bronxville, NY 10708",
  logo: "/logo-emblem.png",
  logoEmblem: "/logo-emblem.png",
  logoLockup: "/logo-lockup.png",
  logoWordmark: "/logo-wordmark.png",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Portals", href: "#portals" },
  { label: "Contact", href: "#contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  aboutInterior: "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&w=1200",
  aboutHome: "https://images.unsplash.com/photo-1505843513577-22bb7d21e455?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  {
    icon: "Building2",
    title: "Residential Management",
    desc: "Full-service oversight for single-family homes, condos, and multifamily communities, handled with discretion and care.",
  },
  {
    icon: "Users",
    title: "Tenant Screening",
    desc: "Rigorous, fair, and compliant screening that places responsible residents and safeguards your investment.",
  },
  {
    icon: "KeyRound",
    title: "Leasing & Marketing",
    desc: "Premium listings, professional showings, and data-driven pricing that minimize vacancy and maximize return.",
  },
  {
    icon: "Wrench",
    title: "Maintenance & Care",
    desc: "24/7 coordinated maintenance with vetted vendors, keeping every home in pristine, code-compliant condition.",
  },
  {
    icon: "Wallet",
    title: "Rent Collection",
    desc: "Reliable, on-time rent collection with secure online payments and consistent, courteous follow-through.",
  },
  {
    icon: "LineChart",
    title: "Financial Reporting",
    desc: "Transparent monthly statements and an owner portal so you always know exactly how your home performs.",
  },
];

export const PORTALS = [
  {
    icon: "Home",
    title: "Owner Portal",
    desc: "View statements, inspection reports, maintenance approvals, and real-time performance for every property you own.",
    points: ["Real-time financial statements", "Maintenance approvals", "Document vault & tax records"],
    cta: "Owner Login",
  },
  {
    icon: "UserRound",
    title: "Resident Portal",
    desc: "Pay rent online, submit maintenance requests, and manage your lease, all from one simple, secure dashboard.",
    points: ["Pay rent online securely", "Submit maintenance requests", "Access lease & documents 24/7"],
    cta: "Resident Login",
  },
];

export const VALUES = [
  { title: "Quality & Integrity", desc: "We hold every property to a high standard and do what is right at every step, without compromise." },
  { title: "Responsible Growth", desc: "We acquire and improve thoughtfully, creating lasting value rather than chasing short-term gains." },
  { title: "Community Focus", desc: "Well-cared-for properties build stronger neighborhoods, and that impact guides every decision we make." },
];

export const STATS = [
  { value: "1,800+", label: "Units Managed" },
  { value: "98%", label: "Occupancy Rate" },
  { value: "20+", label: "Years of Trust" },
  { value: "$420M", label: "Assets Overseen" },
];

export const PORTFOLIO = [
  { src: "https://images.unsplash.com/photo-1756064173162-326c8e85215d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Sterling Estates", type: "Luxury Residential", span: "lg:col-span-8" },
  { src: "https://images.unsplash.com/photo-1530877872966-40bb5529f558?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "The Emerald Residences", type: "Multifamily", span: "lg:col-span-4" },
  { src: "https://images.unsplash.com/photo-1505843513577-22bb7d21e455?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Northgate Homes", type: "Single-Family", span: "lg:col-span-4" },
  { src: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Parkview Lofts", type: "Condominium", span: "lg:col-span-4" },
  { src: "https://images.unsplash.com/photo-1688307193832-a6f711942705?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", title: "Heritage Manor", type: "Townhomes", span: "lg:col-span-4" },
];

export const TESTIMONIALS = [
  { quote: "North Emerald manages our portfolio with a level of integrity we had given up hoping to find. Truly exceptional.", name: "Margaret Ellison", role: "Property Owner" },
  { quote: "Their reporting is flawless and their team is always reachable. Our occupancy has never been higher.", name: "David Chen", role: "Real Estate Investor" },
  { quote: "From maintenance to leasing, every detail is handled with care. They set the standard for the industry.", name: "Sophia Martinez", role: "Condo Owner" },
  { quote: "Honest, responsive, and genuinely high-standard. I recommend them to every owner I know.", name: "James Whitfield", role: "Multifamily Owner" },
];
